<template>
    <CModal
      @mtdclosemodal="mtdClose"
      :show.sync="boo_modal"
      :close-on-backdrop="false"
      :centered="true"
      :title="title"
      :size="'lg'"
      :btn_cancel="true"
      :btn_ok="true"
      :booTitile="true"
      :scrollable="true"
    >
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-12 table-responsive" id="div-tabla-anular">
                <table id="tb-anular" class="table table-bordered">
                    <caption class="mx-0 px-0"></caption>
                    <thead class="bg-main">
                        <tr class="text-white text-center align-middle">
                          <th scope="col">#</th>
                          <th scope="col">Usuario Reg.</th>
                          <th scope="col">Servicio</th>
                          <th scope="col">Fecha</th>
                          <th scope="col">Motivo</th>
                        </tr>
                    </thead>
                    <tbody class="border-main">
                      <tr v-for="(det, index) in cpData" :key="index" class="text-center align-middle">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <template v-if="det.user">
                            {{ det.user.name }} {{ det.user.last_name }}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td>{{ det.subsub_categorie ? det.subsub_categorie.name : '-'}}</td>
                        <td>{{ det.date|formatDate }}</td>
                        <td>{{ det.motivo}}</td>
                      </tr>
                    </tbody>
                </table>
            </div>
  
        </div>
      </div>
    </CModal>
</template>
  
  <script>
  import CModal from "../../shared/modals/CModal.vue";
  import { mapActions } from "vuex";
  import moment from "moment";
  export default {
    name: "c-cxc-cModalHistoDeleteCarrito",
    components: {
      CModal,
    },
    data() {
      return {
        tabla: [],
      };
    },
    created() {},
    computed: {
      cpData() {
        let show = [];
        this.item.forEach((element) => {
          show.push(element);
        });
        this.tabla = show;
        return show;
      },
    },
    props: {
      title: String,
      boo_modal: Boolean,
      item: [],
    },
    methods: {
      ...mapActions(["get", "post"]),

      mtdClose() {
        this.$emit("mtdCloseModalDelete");
      },
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatTime(time) {
            let arTime = time.split(":");
            if (arTime[0] <= 12) {
                return time + " am";
            } else {
                return arTime[0] - 12 + ":" + arTime[1] + ":" + arTime[2] + " pm";
            }
        },
    },
  };
  </script>
  